import { Breadcrumbs } from "components/breadcrumbs";
import { FullScreenLoading } from "components/fullScreenLoading";
import { useOne } from "@refinedev/core";
// import { AffiliateBannerForm, BlogsForm, HeroBannerForm, HotEventsForm, OrganizersForm, PromotionBannerForm, SlideBannerForm, TopBannerForm } from "./components";
import { useState } from "react";
import { IMKTBannerDetail } from "interfaces";
import { BannerForm } from "./components/bannerForm";
import PreviewModal from "./components/previewModal";

export const EditBanner : React.FC = () => {
  
  const [previewImageModalData, setPreviewImageModalData] = useState({
    isOpen: false,
    image: ""
  });

  const {
    data,
    isFetching,
    isPreviousData,
    isLoading,
  } = useOne<IMKTBannerDetail>({
    resource: "mkt/banners",
    id: "",
    meta: {
      resource: "data",
    },
  });

  const bannerDetailData = data?.data;

  if (isLoading) {
    return <FullScreenLoading />
  }

  if (isLoading) {
    return <FullScreenLoading />
  }

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Edit Banner" />
      {bannerDetailData ? (
        <>
          <BannerForm bannerSize={{width: 1440, height: 600}} defaultData={bannerDetailData["sport_list"]} setPreviewImageModalData={setPreviewImageModalData} />
          <BannerForm bannerSize={{width: 1440, height: 600}} defaultData={bannerDetailData["attraction_list"]} setPreviewImageModalData={setPreviewImageModalData} />
          <BannerForm bannerSize={{width: 1440, height: 600}} defaultData={bannerDetailData["transport_station"]} setPreviewImageModalData={setPreviewImageModalData} />
          <BannerForm bannerSize={{width: 1440, height: 600}} defaultData={bannerDetailData["blogs_home"]} setPreviewImageModalData={setPreviewImageModalData} />
          <BannerForm bannerSize={{width: 410}} defaultData={bannerDetailData["blogs_detail"]} setPreviewImageModalData={setPreviewImageModalData} />
          <BannerForm defaultData={bannerDetailData["workspace"]} setPreviewImageModalData={setPreviewImageModalData} />
          <BannerForm defaultData={bannerDetailData["popup_homepage"]} setPreviewImageModalData={setPreviewImageModalData} />
          <BannerForm defaultData={bannerDetailData["popup_payment_status"]} setPreviewImageModalData={setPreviewImageModalData} />
          <BannerForm defaultData={bannerDetailData["homepage_coupon"]} setPreviewImageModalData={setPreviewImageModalData} />
          <PreviewModal 
            open={previewImageModalData.isOpen} 
            onClose={() => setPreviewImageModalData({
              ...previewImageModalData,
              isOpen: false
            })} 
            data={previewImageModalData.image}
          />
        </>
      ) : <></>}
      {(isFetching && isPreviousData) ? <FullScreenLoading /> : <></>}
    </div>
  );
}